<template>
  <div>
    <datatable
      title="Admin Job Titles"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-job-titles',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'name',
          value: 'name'
        }
      ],
      data: [],
      operations: [],
      chosen_text: {}
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllJobTitles().then(response => {
        this.data = response
      })
    },
    editClick (data) {
      this.chosen_text = data
    }
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
